import {
    AUTH_LOGIN_REQUEST,
    AUTH_LOGIN_SUCCESS,
    AUTH_LOGIN_FAIL,
    SecurityActionTypes,
    AUTH_LOGOUT_FAIL,
    AUTH_LOGOUT_SUCCESS,
    AUTH_LOGOUT_REQUEST,
    AUTH_INIT_REQUEST,
    AUTH_INIT_SUCCESS,
    AUTH_INIT_FAIL,
    SecurityInitOptions,
    AUTH_SET_ACCOUNT_URL,
    AUTH_SET_USER_PROFILE,
    SecurityProfile,
    SecurityBusActionTypes,
    AUTH_BUS_LOGIN_REQUEST,
    AUTH_BUS_SUCCESS,
    SecurityTokenPayload,
    AUTH_BUS_FAIL,
    AUTH_BUS_LOGOUT_REQUEST,
    AUTH_SET_USER_ROLES,
    AUTH_SET_TOKEN,
} from './types';

export const authBusLoginRequest = (): SecurityBusActionTypes => ({
    type: AUTH_BUS_LOGIN_REQUEST,
});

export const authBusLogoutRequest = (): SecurityBusActionTypes => ({
    type: AUTH_BUS_LOGOUT_REQUEST,
});

export const authBusSuccess = (payload: SecurityTokenPayload): SecurityBusActionTypes => ({
    type: AUTH_BUS_SUCCESS,
    payload,
});

export const authBusFail = (): SecurityBusActionTypes => ({
    type: AUTH_BUS_FAIL,
});

export const authInitRequest = (options: SecurityInitOptions): SecurityActionTypes => ({
    type: AUTH_INIT_REQUEST,
    payload: options,
});

export const authInitSuccess = (): SecurityActionTypes => ({
    type: AUTH_INIT_SUCCESS,
});

export const authInitFail = (): SecurityActionTypes => ({
    type: AUTH_INIT_FAIL,
});

export const authLoginRequest = (): SecurityActionTypes => ({
    type: AUTH_LOGIN_REQUEST,
});

export const authLoginSuccess = (token): SecurityActionTypes => ({
    type: AUTH_LOGIN_SUCCESS,
    payload: token,
});

export const authLoginFail = (): SecurityActionTypes => ({
    type: AUTH_LOGIN_FAIL,
});

export const authLogoutRequest = (): SecurityActionTypes => ({
    type: AUTH_LOGOUT_REQUEST,
});

export const authLogoutSuccess = (): SecurityActionTypes => ({
    type: AUTH_LOGOUT_SUCCESS,
});

export const authLogoutFail = (): SecurityActionTypes => ({
    type: AUTH_LOGOUT_FAIL,
});

export const authSetAccountUrl = (url: string): SecurityActionTypes => ({
    type: AUTH_SET_ACCOUNT_URL,
    payload: url,
});

export const authSetUserProfile = (profile: SecurityProfile): SecurityActionTypes => ({
    type: AUTH_SET_USER_PROFILE,
    payload: profile,
});

export const authSetUserRoles = (roles: string[]): SecurityActionTypes => ({
    type: AUTH_SET_USER_ROLES,
    payload: roles,
});

export const authSetToken = (token: string): SecurityActionTypes => ({
    type: AUTH_SET_TOKEN,
    payload: token,
});
